import { AxiosInstance } from 'axios';
import { ConfigurationService } from '@/config/configuration-service';
import { getAxiosInstance } from '@chr/online-shared-microsite-core';

export const getChangeRequestReasonTypes = async (request) => {
  const axiosInstance: AxiosInstance = await getAxiosInstance();
  const { poApiUri } = await ConfigurationService.getConfiguration();

  const reasonTypesUri = `${poApiUri}/ReferenceData/ChangeRequestReasonTypes/${request.customerCode}`;
  const response = await axiosInstance.get(reasonTypesUri);

  return response.data;
};
